import { GenericError } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import type { FC, PropsWithChildren } from 'react'
import { useTransferContextProvider } from '../../context'
import { BankInvestmentValidationCard } from '../bank-investment-validation-card/bank-investment-validation-card'
import { MinDepositCard } from '../minimum-deposit-card/minimum-deposit-card'
import { TransferErrorModal } from '../transfer-error-modal/transfer-error-modal'
import { TransferSuccess } from '../transfer-success/transfer-success'
import { TransferUnavailable } from '../transfer-unavailable/transfer-unavailable'

export const TransferFormWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation('features-transfer')

  const { accountData, isAccountDataError, displaySuccess, bankInvestmentValidationError } =
    useTransferContextProvider()

  const showTransferUnavailable = accountData.checkingAccountClosed

  if (showTransferUnavailable) return <TransferUnavailable />

  return (
    <div>
      <div className="w-full">
        {/* Component handles if it should show */}
        <MinDepositCard />

        <BankInvestmentValidationCard bankInvestmentValidationError={bankInvestmentValidationError} />

        {/* If Success Message or Error Message not showing, show Form */}
        {!displaySuccess && !isAccountDataError && children}

        {/* Displaying Success Message, Component Handles If it Should show */}
        <TransferSuccess />

        {/* If Accounts Error && not displaying Success Message show Generic Error */}
        {isAccountDataError && !displaySuccess ? <GenericError errorMessage={t('error.problem')} /> : null}
      </div>
      <TransferErrorModal />
    </div>
  )
}
